// Copyright © 2019 Atomic.io Limited. All rights reserved.

const Logo = ({width, height, style}) => (
  <svg {...{width, height, style}} viewBox="0 0 59 55">
    <g fill="none" fillRule="evenodd">
      <path
        d="M40.86 54.078L34.084 42.24a8.505 8.505 0 0 0-7.385-4.28l-18.424.01a8.056 8.056 0 0 0-8.051 8.055 8.052 8.052 0 0 0 8.051 8.052H40.86z"
        fill="#246CFF"
      />
      <path
        d="M6.282 33.432l13.545.01a8.505 8.505 0 0 0 7.387-4.278l9.257-16.161a8.062 8.062 0 0 0-2.944-10.977 7.964 7.964 0 0 0-10.911 2.923L6.282 33.432z"
        fill="#FF395A"
      />
      <path
        d="M41.278 13.706L34.496 25.43a8.505 8.505 0 0 0 .012 8.536l9.367 16.097a8.062 8.062 0 0 0 10.979 2.939 7.964 7.964 0 0 0 2.924-10.911l-16.5-28.386z"
        fill="#FFC7D7"
      />
    </g>
  </svg>
)

const FullLogo = () => (
  <svg
    width="105"
    height="20"
    viewBox="0 0 105 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="full-logo"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.3466 12.044L35.4879 11.5613C36.2141 11.4541 36.4479 11.0794 36.4479 10.6242C36.4479 9.68636 35.747 8.90941 34.2933 8.90941C32.7877 8.90941 31.9569 9.90087 31.8536 11.0525L28.7903 10.3829C28.9981 8.32017 30.8409 6.04297 34.268 6.04297C38.3173 6.04297 39.8224 8.40061 39.8224 11.0525V17.5356C39.8224 18.2321 39.9003 19.1699 39.9783 19.6251H36.8117C36.7337 19.2765 36.6817 18.5532 36.6817 18.0444C36.0328 19.0895 34.8123 19.9998 32.9176 19.9998C30.192 19.9998 28.5311 18.098 28.5311 16.0353C28.5311 13.6777 30.218 12.3651 32.3466 12.044ZM36.5006 14.2746V13.6689L33.6956 14.1369C32.8361 14.2746 32.1536 14.797 32.1536 15.8419C32.1536 16.6396 32.6843 17.4099 33.7715 17.4099C35.1863 17.4099 36.5006 16.6672 36.5006 14.2746Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.5519 6.48667H49.107V9.61399H46.5519V15.074C46.5519 16.2142 47.068 16.5849 48.049 16.5849C48.4618 16.5849 48.9261 16.5319 49.107 16.4788V19.3946C48.797 19.5272 48.1776 19.7123 47.1713 19.7123C44.6931 19.7123 43.145 18.202 43.145 15.6842V9.61399H40.8476V6.48667H41.4928C42.835 6.48667 43.4543 5.58529 43.4543 4.41926V2.58997H46.5519V6.48667Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M63.3446 13.0216C63.3446 17.0595 60.4456 20 56.6068 20C52.7679 20 49.8689 17.0595 49.8689 13.0216C49.8689 8.95769 52.7679 6.04321 56.6068 6.04321C60.4456 6.04321 63.3446 8.95769 63.3446 13.0216ZM59.867 12.9494C59.867 10.4645 58.3025 9.20868 56.6068 9.20868C54.9117 9.20868 53.3465 10.4645 53.3465 12.9494C53.3465 15.4081 54.9117 16.6907 56.6068 16.6907C58.3025 16.6907 59.867 15.4349 59.867 12.9494Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M88.4665 0C89.6456 0 90.5676 0.973578 90.5676 2.18495C90.5676 3.34297 89.6456 4.31655 88.4665 4.31655C87.3131 4.31655 86.3655 3.34297 86.3655 2.18495C86.3655 0.973578 87.3131 0 88.4665 0ZM86.8002 6.47482H90.1329V19.5683H86.8002V6.47482Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M95.2818 13.0216C95.2818 15.4015 96.7772 16.7383 98.53 16.7383C100.283 16.7383 101.16 15.5353 101.443 14.519L104.459 15.5621C103.892 17.754 101.907 20 98.53 20C94.7916 20 91.853 17.0595 91.853 13.0216C91.853 8.95769 94.7399 6.04321 98.4268 6.04321C101.881 6.04321 103.841 8.26252 104.382 10.4818L101.314 11.551C101.005 10.4551 100.205 9.33237 98.5042 9.33237C96.7508 9.33237 95.2818 10.6424 95.2818 13.0216Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.9568 19.6371V6.4865H68.2898V8.08978C68.9983 6.80689 70.651 6.11194 72.068 6.11194C73.8258 6.11194 75.2435 6.88716 75.8988 8.30382C76.9224 6.70054 78.2869 6.11194 79.9928 6.11194C82.3803 6.11194 84.6634 7.58211 84.6634 11.1104V19.6371H81.2785V11.8321C81.2785 10.4154 80.5962 9.34658 78.9954 9.34658C77.4996 9.34658 76.6073 10.5225 76.6073 11.9391V19.6371H73.1442V11.8321C73.1442 10.4154 72.4357 9.34658 70.8605 9.34658C69.3391 9.34658 68.4468 10.4957 68.4468 11.9391V19.6371H64.9568Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1501 19.6747H2.98153C1.33488 19.6747 0 18.3398 0 16.6932C0 15.0463 1.33463 13.711 2.98153 13.7101L9.87661 13.7067C11.0109 13.7061 12.059 14.3114 12.6254 15.2941L15.1501 19.6747Z"
      fill="#1E6EFA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25888 12.0296L8.34318 1.49126C9.16651 0.0652191 10.99 -0.42338 12.416 0.399947C13.8423 1.2234 14.3314 3.04688 13.5086 4.47354L10.0641 10.4466C9.49748 11.4292 8.44916 12.0342 7.31491 12.0334L2.25888 12.0296Z"
      fill="#FF3C5A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3441 4.68799L21.4284 15.2263C22.2517 16.6524 21.7631 18.4758 20.337 19.2992C18.9108 20.1226 17.0871 19.6344 16.2629 18.2086L12.8123 12.239C12.2447 11.257 12.2449 10.0466 12.8127 9.06473L15.3441 4.68799Z"
      fill="#FFC5CE"
    />
  </svg>
)

const MagicIcon = () => (
  <div className="icon-contain">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="magic-icon"
    >
      <path
        d="M7 10C10.3137 10 13 7.31371 13 4C13 7.31371 15.6863 10 19 10C15.6863 10 13 12.6863 13 16C13 12.6863 10.3137 10 7 10Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 16C2.65685 16 4 14.6569 4 13C4 14.6569 5.34315 16 7 16C5.34315 16 4 17.3431 4 19C4 17.3431 2.65685 16 1 16Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3C6.10457 3 7 2.10457 7 1C7 2.10457 7.89543 3 9 3C7.89543 3 7 3.89543 7 5C7 3.89543 6.10457 3 5 3Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
)

const SettingsIcon = () => (
  <div className="icon-contain">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.93782 8.23206L2.43782 9.09808L2.93782 8.23206ZM4.01291 9.60356L3.01503 9.53847L4.01291 9.60356ZM3.48838 8.54992L3.98838 7.6839L3.48838 8.54992ZM2.57183 13.134L1.70581 13.634L2.57183 13.134ZM4.93786 15.232L5.43786 16.0981L4.93786 15.232ZM3.57183 14.866L2.70581 15.366L3.57183 14.866ZM12.6512 15.384L13.0937 16.2808L12.6512 15.384ZM16.4282 14.866L17.2942 15.366L16.4282 14.866ZM15.9871 10.3965L16.985 10.4616L15.9871 10.3965ZM16.5116 11.4501L16.0116 12.3161L16.5116 11.4501ZM16.5116 8.54992L16.0116 7.68389L16.5116 8.54992ZM17.4282 6.86602L18.2943 6.36602L17.4282 6.86602ZM15.0622 4.76794L15.5622 5.63397L15.0622 4.76794ZM16.4282 5.13397L15.5622 5.63397L16.4282 5.13397ZM13.3359 5.01205L12.7792 5.84278L13.3359 5.01205ZM14.5118 5.08574L14.0118 4.21971L14.5118 5.08574ZM12.6512 4.61604L12.2088 5.51283L12.6512 4.61604ZM14.5118 14.9143L14.0118 15.7803L14.5118 14.9143ZM13.3358 14.988L12.7792 14.1572L13.3358 14.988ZM3.57179 5.13398L2.70577 4.63398L3.57179 5.13398ZM4.93782 4.76795L4.43782 5.63398L4.93782 4.76795ZM11 1H9.00002V3H11V1ZM13 3.63424V3H11V3.63424H13ZM13.8925 4.18132C13.6377 4.01056 13.3709 3.85603 13.0937 3.71924L12.2088 5.51283C12.4066 5.6104 12.597 5.72073 12.7792 5.84278L13.8925 4.18132ZM14.5622 3.90192L14.0118 4.21971L15.0118 5.95176L15.5622 5.63397L14.5622 3.90192ZM18.2943 6.36602L17.2943 4.63397L15.5622 5.63397L16.5622 7.36602L18.2943 6.36602ZM17.0116 9.41594L17.5622 9.09807L16.5622 7.36602L16.0116 7.68389L17.0116 9.41594ZM17 10C17 9.84506 16.995 9.69116 16.985 9.53846L14.9892 9.66865C14.9964 9.77804 15 9.88852 15 10H17ZM16.985 10.4616C16.995 10.3089 17 10.1549 17 10H15C15 10.1115 14.9964 10.222 14.9892 10.3314L16.985 10.4616ZM17.5622 10.9019L17.0116 10.5841L16.0116 12.3161L16.5622 12.634L17.5622 10.9019ZM17.2942 15.366L18.2942 13.634L16.5622 12.634L15.5622 14.366L17.2942 15.366ZM14.0118 15.7803L14.5622 16.0981L15.5622 14.366L15.0118 14.0483L14.0118 15.7803ZM13.0937 16.2808C13.3709 16.144 13.6377 15.9894 13.8925 15.8187L12.7792 14.1572C12.597 14.2793 12.4066 14.3896 12.2088 14.4872L13.0937 16.2808ZM13 17V16.3658H11V17H13ZM9.00002 19H11V17H9.00002V19ZM7.00002 16.3658V17H9.00002V16.3658H7.00002ZM6.10751 15.8187C6.36232 15.9894 6.62909 16.144 6.90633 16.2808L7.79123 14.4872C7.59348 14.3896 7.40299 14.2793 7.22086 14.1572L6.10751 15.8187ZM5.43786 16.0981L5.98826 15.7803L4.98826 14.0482L4.43786 14.366L5.43786 16.0981ZM1.70581 13.634L2.70581 15.366L4.43786 14.366L3.43786 12.634L1.70581 13.634ZM2.98839 10.5841L2.43786 10.9019L3.43786 12.634L3.98839 12.3161L2.98839 10.5841ZM3.00002 10C3.00002 10.1549 3.00507 10.3088 3.01503 10.4615L5.01079 10.3314C5.00365 10.222 5.00002 10.1115 5.00002 10H3.00002ZM3.01503 9.53847C3.00507 9.69117 3.00002 9.84506 3.00002 10H5.00002C5.00002 9.88853 5.00365 9.77804 5.01078 9.66865L3.01503 9.53847ZM2.43782 9.09808L2.98838 9.41595L3.98838 7.6839L3.43782 7.36603L2.43782 9.09808ZM2.70577 4.63398L1.70577 6.36603L3.43782 7.36603L4.43782 5.63398L2.70577 4.63398ZM5.98824 4.21972L5.43782 3.90193L4.43782 5.63398L4.98824 5.95177L5.98824 4.21972ZM6.90633 3.71924C6.62908 3.85603 6.36231 4.01056 6.10749 4.18132L7.22084 5.84278C7.40298 5.72073 7.59347 5.6104 7.79123 5.51283L6.90633 3.71924ZM7.00002 3V3.63423H9.00002V3H7.00002ZM11 10C11 10.5523 10.5523 11 10 11V13C11.6569 13 13 11.6569 13 10H11ZM10 9C10.5523 9 11 9.44772 11 10H13C13 8.34315 11.6569 7 10 7V9ZM9.00002 10C9.00002 9.44772 9.44773 9 10 9V7C8.34316 7 7.00002 8.34315 7.00002 10H9.00002ZM10 11C9.44773 11 9.00002 10.5523 9.00002 10H7.00002C7.00002 11.6569 8.34316 13 10 13V11ZM7.79123 5.51283C8.45102 5.18731 9.00002 4.50299 9.00002 3.63423H7.00002C7.00002 3.62788 7.00293 3.63248 6.99081 3.65025C6.97698 3.67053 6.94909 3.69815 6.90633 3.71924L7.79123 5.51283ZM3.43782 7.36603L1.70577 6.36603C1.15348 7.32262 1.48123 8.5458 2.43782 9.09808L3.43782 7.36603ZM5.01078 9.66865C5.05869 8.93423 4.73977 8.11771 3.98838 7.6839L2.98838 9.41595C2.98297 9.41282 2.98838 9.41263 2.99764 9.43184C3.0082 9.45376 3.0181 9.49136 3.01503 9.53847L5.01078 9.66865ZM3.98839 12.3161C4.73978 11.8823 5.05869 11.0658 5.01079 10.3314L3.01503 10.4615C3.0181 10.5087 3.0082 10.5463 2.99764 10.5682C2.98838 10.5874 2.98297 10.5872 2.98839 10.5841L3.98839 12.3161ZM3.43786 12.634L3.43786 12.634L2.43786 10.9019C1.48127 11.4542 1.15352 12.6774 1.70581 13.634L3.43786 12.634ZM4.43786 14.366L2.70581 15.366C3.25809 16.3226 4.48127 16.6504 5.43786 16.0981L4.43786 14.366ZM7.22086 14.1572C6.60863 13.747 5.74079 13.6138 4.98826 14.0482L5.98826 15.7803C5.9828 15.7834 5.98527 15.7787 6.00649 15.7803C6.03072 15.7821 6.06824 15.7924 6.10751 15.8187L7.22086 14.1572ZM9.00002 16.3658C9.00002 15.497 8.45102 14.8127 7.79123 14.4872L6.90633 16.2808C6.94909 16.3019 6.97698 16.3295 6.99081 16.3497C7.00293 16.3675 7.00002 16.3721 7.00002 16.3658H9.00002ZM9.00002 17H7.00002C7.00002 18.1046 7.89545 19 9.00002 19V17ZM11 17V19C12.1046 19 13 18.1046 13 17H11ZM12.2088 14.4872C11.549 14.8127 11 15.497 11 16.3658H13C13 16.3721 12.9971 16.3675 13.0092 16.3497C13.0231 16.3295 13.0509 16.3019 13.0937 16.2808L12.2088 14.4872ZM15.5622 14.366L14.5622 16.0981C15.5188 16.6504 16.7419 16.3226 17.2942 15.366L15.5622 14.366ZM16.5622 12.634H16.5622L18.2942 13.634C18.8465 12.6774 18.5188 11.4542 17.5622 10.9019L16.5622 12.634ZM14.9892 10.3314C14.9413 11.0658 15.2603 11.8823 16.0116 12.3161L17.0116 10.5841C17.0171 10.5872 17.0117 10.5874 17.0024 10.5682C16.9918 10.5463 16.9819 10.5087 16.985 10.4616L14.9892 10.3314ZM16.0116 7.68389C15.2603 8.11771 14.9413 8.93422 14.9892 9.66865L16.985 9.53846C16.9819 9.49135 16.9918 9.45375 17.0024 9.43183C17.0117 9.41262 17.0171 9.41281 17.0116 9.41594L16.0116 7.68389ZM16.5622 7.36602H16.5622L17.5622 9.09807C18.5188 8.54579 18.8465 7.32261 18.2943 6.36602L16.5622 7.36602ZM15.5622 5.63397H15.5622L17.2943 4.63397C16.742 3.67738 15.5188 3.34963 14.5622 3.90192L15.5622 5.63397ZM12.7792 5.84278C13.3914 6.25303 14.2592 6.38624 15.0118 5.95176L14.0118 4.21971C14.0172 4.21656 14.0148 4.22133 13.9936 4.21973C13.9693 4.2179 13.9318 4.20763 13.8925 4.18132L12.7792 5.84278ZM11 3.63424C11 4.50299 11.549 5.18731 12.2088 5.51283L13.0937 3.71924C13.0509 3.69815 13.0231 3.67053 13.0092 3.65025C12.9971 3.63248 13 3.62788 13 3.63424H11ZM4.98824 5.95177C5.74078 6.38624 6.60862 6.25304 7.22084 5.84278L6.10749 4.18132C6.06822 4.20764 6.03071 4.2179 6.00647 4.21973C5.98525 4.22134 5.98278 4.21656 5.98824 4.21972L4.98824 5.95177ZM9.00002 1C7.89545 1 7.00002 1.89543 7.00002 3H9.00002V1ZM15.0118 14.0483C14.2592 13.6138 13.3914 13.747 12.7792 14.1572L13.8925 15.8187C13.9318 15.7924 13.9693 15.7821 13.9935 15.7803C14.0148 15.7787 14.0172 15.7835 14.0118 15.7803L15.0118 14.0483ZM4.43782 5.63398L4.43782 5.63398L5.43782 3.90193C4.48123 3.34964 3.25805 3.67739 2.70577 4.63398L4.43782 5.63398ZM11 3V3H13C13 1.89543 12.1046 1 11 1V3Z"
        fill="black"
      />
    </svg>
  </div>
)

const SettingsTrigger = ({className, onClick, isOpen}) => (
  <button
    className={
      isOpen
        ? `trigger-open dropdown-trigger settings-trigger button-light ${className}`
        : `dropdown-trigger settings-trigger button-light ${className}`
    }
    onClick={onClick}
  >
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.996 2a2 2 0 012-2h4a2 2 0 012 2v1.78c0 .003.003.006.007.012a.14.14 0 00.058.045 9.988 9.988 0 011.848 1.059c.025.018.05.025.066.026h.013l1.535-.886a2 2 0 012.732.732l2 3.464a2 2 0 01-.732 2.732l-1.514.874a.045.045 0 00-.007.011.14.14 0 00-.01.072 10.103 10.103 0 010 2.158.138.138 0 00.01.072c.003.006.005.01.007.01l1.514.875a2 2 0 01.732 2.732l-2 3.464a2 2 0 01-2.732.732l-1.535-.886h-.013a.137.137 0 00-.066.027 9.99 9.99 0 01-1.848 1.058.14.14 0 00-.058.045.044.044 0 00-.007.011V24a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1.828a.045.045 0 00-.006-.011.138.138 0 00-.056-.045 9.992 9.992 0 01-1.79-1.045.137.137 0 00-.067-.028h-.013l-1.594.921a2 2 0 01-2.732-.732l-2-3.464a2 2 0 01.732-2.732l1.614-.932a.044.044 0 00.007-.01.138.138 0 00.01-.072 10.106 10.106 0 010-2.044.138.138 0 00-.01-.071.042.042 0 00-.007-.01l-1.614-.933a2 2 0 01-.732-2.732l2-3.464a2 2 0 012.732-.732l1.594.92h.013a.137.137 0 00.067-.027 9.992 9.992 0 011.79-1.045.138.138 0 00.056-.045.043.043 0 00.006-.011V2zm0 1.827zM7.064 4.956h.001zm-3.979 6.94zm3.98 9.148zM18.988 4.922zM16.996 3.78v.001-.001zm-2-1.78h-4v1.829c0 .858-.538 1.56-1.238 1.877-.508.23-.987.51-1.432.837-.626.458-1.512.578-2.261.146L4.47 5.768l-2 3.464 1.615.932c.744.43 1.084 1.25 1.006 2.016a8.106 8.106 0 000 1.64c.078.766-.262 1.586-1.006 2.016l-1.615.932-.5-.866 2.5 4.33 1.595-.92c.75-.433 1.635-.313 2.261.145.445.326.924.607 1.432.837.7.316 1.238 1.02 1.238 1.877V24h4v-1.782c0-.867.55-1.575 1.262-1.887a7.985 7.985 0 001.478-.846c.625-.453 1.506-.57 2.251-.14l1.536.887 2-3.464-1.515-.875c-.748-.432-1.087-1.257-1.005-2.028a8.1 8.1 0 000-1.73c-.082-.77.257-1.596 1.005-2.028l1.515-.875-2-3.464-1.536.886c-.745.43-1.626.314-2.251-.139a7.99 7.99 0 00-1.478-.846c-.712-.312-1.262-1.02-1.262-1.887V2zm-2 9a2 2 0 100 4 2 2 0 000-4zm-4 2a4 4 0 118 0 4 4 0 01-8 0z" />
    </svg>
  </button>
)

const AtomicLogo = ({children, href, target, title}) => (
  <a
    className="dropdown-trigger button-light"
    href={href}
    target={target}
    title={title}
  >
    {children}
  </a>
)

const Check = () => (
  <svg height="8" width="11" viewBox="0 0 11 8">
    <path d="M10.707.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-3-3a1 1 0 011.414-1.414L4 5.586 9.293.293a1 1 0 011.414 0z"></path>
  </svg>
)

const CloseIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L13 13M13 1L1 13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)

export {
  Logo,
  FullLogo,
  SettingsIcon,
  SettingsTrigger,
  MagicIcon,
  AtomicLogo,
  Check,
  CloseIcon,
}
